const initVideoBootcamp = () => {
    const videoBootcamp = document.querySelector('#terminar-video-bootcamp');

    if (!videoBootcamp) return;

    const check = document.querySelector('input.check-input');
    
    check.addEventListener('change', () => {
        videoBootcamp.disabled = !check.checked;
    });

    const protocol = window.location.protocol;
    const hostname = window.location.hostname;

    videoBootcamp.addEventListener('click', async () => {
        const user_id = videoBootcamp.getAttribute('data-id');
        const restBase = protocol + '//' + hostname + '/wp-json/video-bootcamp-rest/v1';

        const data = {
            action: 'user_acciones_rest',
            user_id,
        };

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': user_acciones_rest.apiNonce,
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                data: data,
            }),
        };

        fetch(restBase + '/update', options)
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // Mostrar mensaje de éxito
                    alert('Video completado correctamente');
                    window.location.href = '/mi-cuenta/bootcamp-temario/';
                } else {
                    // Mostrar mensaje de error
                    alert(data.message);
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert('Ocurrió un error al completar el video');
            }); 
    });
};

export default initVideoBootcamp;
